import routes from '@configs/api'

export const GET_USET_MY_COURSES_URL = () => {
  return routes.MY_COURSES
}
export const GET_NOTIFICATIONS_URL = (
  userId: string,
  page: number,
  limit: number
) => {
  return routes.NOTIFICATIONS + `/user/${userId}?page=${page}&limit=${limit}`
}
